// Базовый домен фронтенда/бекенда.
// Можно переопределить через VITE_URL_DOMAIN в .env фронтенда.
const runtimeHost = typeof window !== 'undefined' ? window.location.host : ''
const envDomain = import.meta.env.VITE_URL_DOMAIN || ''
const hasPlaceholderDomain = envDomain.includes('example.com')

export const URL_DOMAIN = runtimeHost && (hasPlaceholderDomain || !envDomain)
    ? runtimeHost
    : (envDomain || 'xn--90aqmw5d.xn--p1ai')

// Базовый URL API - пустая строка, так как axios использует baseURL
// Все пути относительные: '/auth/login', '/listings', etc.
export const API_BASE_URL = '';

// Токены аутентификации
export const AUTH_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const REFERRAL_CODE = 'referral_code';

// Настройки уведомлений
export const TOAST_OPTIONS = {
    success: 'login-success',
    error: 'login-error',
};

export const ROLE_ADMIN = 'admin';

// TTL кэша прав (мс)
export const PERMISSIONS_TTL_MS = 120000; // 2 минуты

// Идентификаторы уведомлений, чтобы не спамить тостами при быстрых переходах
export const NOTIFY = {
    requireAuth: 'guard-require-auth',
    accessDenied: 'guard-access-denied',
    sessionExpired: 'guard-session-expired',
    requireConfirmedEmail: 'guard-require-confirmed-email',
    pushNotification: 'push-notification-toast',
    pushChatMessage: 'push-chat-message-toast',
};

// Базовый троттлинг уведомлений (мс)
export const NOTIFY_THROTTLE_MS = 2000;

// Типы листингов
export const LISTING_TYPES = {
    VACANCY: 'vacancy',
    RESUME: 'resume',
    OFFERING: 'offering',
    PRODUCT: 'product',
    REALTY: 'realty',
};

export const VACANCY = LISTING_TYPES.VACANCY;
export const RESUME = LISTING_TYPES.RESUME;
export const OFFERING = LISTING_TYPES.OFFERING;
export const PRODUCT = LISTING_TYPES.PRODUCT;
export const REALTY = LISTING_TYPES.REALTY;

// UI константы
export const HEADER_HEIGHT = 155;
export const HEADER_HEIGHT_MOBILE = 250;
export const SCREEN_HEIGHT_768 = 768;
export const SCREEN_HEIGHT_1024 = 1024;

// Timezone constants for date formatting
export const TIMEZONE_UTC = 'utc';
export const TIMEZONE_LOCAL = 'local';
